export default __webpack_public_path__ + "static/media/bb_guess_2.0b353021.png";